module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullHeight"
  }, [(_vm.showFlashMessage) ? _c('mu-flexbox', {
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('MessageBox', {
    attrs: {
      "message-type": _vm.flashMessageType,
      "message": _vm.flashMessageBody,
      "title": _vm.flashMessageTitle
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1), _vm._v(" "), _c('mu-row')], 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('mu-flexbox', {
    class: {
      'fullHeight': !_vm.showFlashMessage
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "animated fadeInDown",
    attrs: {
      "desktop": "40",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "formWrap"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "titleClass": "blueTitle largeTitle formTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "name": "login"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "id": "emailTxt",
      "name": "email",
      "data-vv-name": "email",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesEmail'),
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('email'),
      "label": _vm.$t('message.accountPreferencesEmail'),
      "type": "email",
      "hintText": _vm.$t('message.accountPreferencesEmail'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "passwordTxt",
      "type": _vm.passwordVisible === true ? 'text' : 'password',
      "data-vv-rules": 'required',
      "data-vv-name": "password",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesPassword'),
      "label": _vm.$t('message.accountPreferencesPassword'),
      "errorText": _vm.errors.first('password'),
      "hintText": _vm.$t('message.accountPreferencesPassword'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticClass: "right-icon",
    attrs: {
      "icon": !_vm.passwordVisible ? 'visibility' : 'visibility_off'
    },
    nativeOn: {
      "click": function($event) {
        _vm.passwordVisible = !_vm.passwordVisible
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.captchaSiteKey,
      "loadRecaptchaScript": false
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', [_c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.loginRememberMe')
    },
    model: {
      value: (_vm.remember_me),
      callback: function($$v) {
        _vm.remember_me = $$v
      },
      expression: "remember_me"
    }
  })], 1), _vm._v(" "), _c('mu-col', [_c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginForgotPassword')))])], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "buttonPrimary",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoggingIn || !_vm.captchaFilled,
      "label": _vm.isLoggingIn ? _vm.$t('message.loggingInText') : _vm.$t('message.logInText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flexbox', [_c('div', {
    staticClass: "optionSpacer"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])]), _vm._v(" "), _c('mu-flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, _vm._l((_vm.providers), function(provider, index) {
    return _c('mu-flexbox-item', {
      key: ("provider-" + index)
    }, [_c('mu-raised-button', {
      staticClass: "loginButton",
      class: {
        darkTextButton: provider.brandColour === '#ffffff',
        buttonImageOnly: !provider.buttonText || !provider.buttonText.length
      },
      style: ({
        backgroundColor: provider.brandColour,
        backgroundImage: provider.buttonText ? '' : ("url(" + (provider.image) + ")")
      }),
      attrs: {
        "type": "button",
        "full-width": "",
        "label": provider.buttonText && provider.buttonText.length ? provider.title.toString().replace(/^/, 'Sign in with ') : '',
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.connectAccount(provider.connectUrl)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": provider.image
      }
    })])], 1)
  }), 1), _vm._v(" "), _c('mu-row', {
    staticClass: "noAccount"
  }, [_c('mu-col', [_vm._v("\n                    " + _vm._s(_vm.$t('message.loginNoAccountYet')) + "\n                  ")]), _vm._v(" "), _c('mu-col', [(_vm.offerCode) ? _c('div', [_c('router-link', {
    attrs: {
      "to": ("/register?oc=" + _vm.offerCode)
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginSignUp')))])], 1) : _c('div', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.loginSignUp')))])], 1)])], 1), _vm._v(" "), (_vm.hasError) ? _c('alert', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "0"
    },
    attrs: {
      "type": "danger",
      "icon": "error"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.errorMessage || _vm.$t('message.loginErrorIncorrectCredentials')) + "\n                  ")])]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "25"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/logos/lcp-logo.svg"),
      "width": "312",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c11002a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login/Login.vue
// module id = 3715
// module chunks = 1